export const HANDOVERLIST_LOADING = "HANDOVERLIST_LOADING";
export const HANDOVERLIST_RESET = "HANDOVERLIST_RESET";
export const GET_HANDOVERLIST = "GET_HANDOVERLIST";
export const GET_HANDOVERLIST_SUCCESS = "GET_HANDOVERLIST_SUCCESS";
export const GET_HANDOVERLIST_FAIL = "GET_HANDOVERLIST_FAIL";
export const DELETE_HANDOVERLIST = "DELETE_HANDOVERLIST"
export const DELETE_HANDOVERLIST_SUCCESS = "DELETE_HANDOVERLIST_SUCCESS"
export const DELETE_HANDOVERLIST_FAIL = "DELETE_HANDOVERLIST_FAIL"
export const UPDATE_HANDOVERLIST = "UPDATE_HANDOVERLIST"
export const UPDATE_HANDOVERLIST_SUCCESS = "UPDATE_HANDOVERLIST_SUCCESS"
export const UPDATE_HANDOVERLIST_FAIL = "UPDATE_HANDOVERLIST_FAIL"
export const ADD_NEW_HANDOVERLIST = "ADD_NEW_HANDOVERLIST"
export const ADD_HANDOVERLIST_SUCCESS = "ADD_HANDOVERLIST_SUCCESS"
export const ADD_HANDOVERLIST_FAIL = "ADD_HANDOVERLIST_FAIL"